import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import {
  Box, Breadcrumbs, Divider, Stack, Typography,
} from "@mui/material";
import { Trans } from "@lingui/macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import _ from "lodash";
import { Link } from "gatsby";
import { faAngleRight } from "@fortawesome/pro-regular-svg-icons";
import { useLocalization } from "gatsby-theme-i18n";
import styled from "@emotion/styled";
import Container from "./Container";
import { restHeaders, headers, additionalLinks } from "../utils/navbar";
import { theme } from "../theme";
import Seo from "./seo";
import Footer from "./footer";
import Navbar from "./Navbar";
import Doc from "../services/DocService";
import ModalFooterCookies from "./ModalFooterCookies";

function NewLayout({
  children, apps, downloadRef, byDefault = false, showOptions = false, withoutNavbar = false, metadata = null,
}) {
  const { locale } = useLocalization();

  const getLinks = (items = { ...restHeaders(), ...headers(), ...additionalLinks() }, level = 0, result = [], arrayLinks = apps?.split(".")) => {
    const currentItem = _.get(items, arrayLinks[level]);
    if (currentItem) {
      result.push({ label: currentItem?.label, path: currentItem?.path, metadata: currentItem?.metadata });
      currentItem?.elements && getLinks(currentItem.elements, level + 1, result);
    }
    return result;
  };

  const breadcrumbs = typeof apps === "string" ? getLinks() : apps;
  const currentMetadata = metadata || _.last(breadcrumbs || {})?.metadata || {};

  const createPdf = () => downloadRef && Doc.createPdf(downloadRef.ref.current, downloadRef.title);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Seo
        title={currentMetadata.title?.label}
        description={currentMetadata.description?.label}
      />
      {!withoutNavbar && <Navbar />}
      <ModalFooterCookies />
      <Box>
        {byDefault && (
          <>
            <StyledBox sx={{ height: { xs: showOptions ? "150px" : "120px", sm: "250px" } }}>
              {showOptions && (
                <Box>
                  <Stack spacing={1} padding={1} direction="row">
                    <Typography>
                      <Trans>Share this page</Trans>
                    </Typography>
                    <Divider orientation="vertical" flexItem />
                    <Typography onClick={createPdf}>pdf</Typography>
                    <FontAwesomeIcon
                      icon={faLinkedin}
                      onClick={() => window.open("https://www.linkedin.com/company/allfunds-wealthtech/mycompany/")}
                    />
                  </Stack>
                </Box>
              )}
            </StyledBox>
            {apps && (
              <Container pt={3}>
                <Stack spacing={2}>
                  <StyledBreadcrumbs
                    separator={<FontAwesomeIcon icon={faAngleRight} />}
                  >
                    <Link to="/">
                      <Typography>
                        <Trans>Home</Trans>
                      </Typography>
                    </Link>
                    {breadcrumbs.map(({ path, label }) => (
                      <Box>
                        {path ? (
                          <Link to={`/${locale}${path}`}>
                            <Typography>{label}</Typography>
                          </Link>
                        ) : (
                          <Typography>{label}</Typography>
                        )}
                      </Box>
                    ))}
                  </StyledBreadcrumbs>
                </Stack>
              </Container>
            )}
          </>
        )}
        {children}
      </Box>
      <Footer />
    </ThemeProvider>
  );
}

const StyledBox = styled(Box)(({ theme }) => `
  display: flex;
  align-items: end;
  background: linear-gradient(90deg, #1a365d 0%, #d50032 100%);
  > div {
    display: flex;
    justify-content: end;
    padding: 0 36px;
    ${theme.breakpoints.down("sm")} {
      padding: 0;
    }
    width: 95%;
    marginleft: auto;
    marginright: auto;
    > div {
      text-align: center;
      align-items: center;
      background: white;
      border-radius: 5px 5px 0px 0px;
      * {
        font-size: 16px;
        &:not(:first-child) {
          cursor: pointer;
        }
      }
    }
  }
`);

const StyledBreadcrumbs = styled(Breadcrumbs)`
  li {
    svg {
      height: 15px;
    }
    * {
      text-decoration: none;
      font-size: 16px;
    }
  }
`;

export default NewLayout;
